export enum LOTTIE_ERROR_TYPES {
    FETCH_FAILED = "FETCH_FAILED",
    TIMEOUT = "TIMEOUT",
    LOTTIE_ERROR = "LOTTIE_ERROR",
    ASSET_FETCH_ERROR = "ASSET_FETCH_ERROR",
    INCOMPLETE_DATA = "INCOMPLETE_DATA",
    UNKNOWN = "UNKNOWN",
}

export type OnLottieError = (errorType?: LOTTIE_ERROR_TYPES, error?: unknown) => void;

export type LottieLayer = { t: any; ty: number; nm: string | string[] };
